const examGrade = {
  path: 'examGrade',
  component: resolve => require(['../../../../components/pages/signUp/examGrade'], resolve)
}
export default examGrade
